var _defs, _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCjLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 801,
    height: 801,
    viewBox: "0 0 801 801",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#025450;}.cls-2{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M400.5,.43C179.94,.43,.48,179.84,.48,400.43s179.47,400,400.02,400,399.98-179.44,399.98-400S621.05,.43,400.5,.43Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M600.49,288.45h-237.18c-3.14,0-5.8,2.25-6.33,5.34l-11.08,64.99c-.32,1.87,.2,3.78,1.42,5.22,1.22,1.45,3.01,2.28,4.91,2.28h152.08c3.17,0,6.17,1.39,8.22,3.82,2.05,2.42,2.92,5.61,2.38,8.74l-26.05,152.8c-4.38,25.71-28.88,46.62-54.6,46.62h-120.35c-3.14,0-5.81,2.25-6.33,5.34l-11.08,65c-.32,1.87,.2,3.78,1.42,5.22,1.22,1.45,3.01,2.28,4.91,2.28h117.42c69.02,0,134.75-56.16,146.52-125.19l40.06-234.97c.32-1.87-.2-3.78-1.42-5.22s-3.01-2.28-4.91-2.28Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M425.75,507.06l11.08-65c.32-1.87-.2-3.78-1.42-5.22-1.22-1.45-3.01-2.28-4.91-2.28h-117.42c-12.48,0-23.46-4.86-30.91-13.69-7.59-9-10.58-20.95-8.41-33.66l20.12-118.01c4.38-25.71,28.87-46.62,54.6-46.62h120.35c3.14,0,5.8-2.25,6.33-5.34l11.08-65c.32-1.87-.2-3.78-1.43-5.23s-3.01-2.28-4.91-2.28h-117.42c-69.02,0-134.75,56.16-146.52,125.19l-20.12,118.01c-5.72,33.57,2.09,65.05,22,88.64,19.5,23.1,48.34,35.83,81.22,35.83h120.35c3.14,0,5.81-2.25,6.33-5.34Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M714.21,723.43v6.34h-13.42v37.16h-7.15v-37.16h-13.42v-6.34h33.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M728.88,723.43l13.92,34.24,13.67-34.24h9.07v43.49h-6.9v-32l-13.05,32h-6.03l-13.05-32v32h-6.9v-43.49h9.26Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCjLogo);
export default __webpack_public_path__ + "static/media/cj-logo.f7c7961287242d801948f20b03bf4042.svg";
export { ForwardRef as ReactComponent };